import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { accessibility,containers,grid,sidebar } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { arrowBack, arrow } from '../../utilities/icons';
import { ContextProvider} from '@lit/context';
import { locationListingsContext } from '../../utilities/context';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInListingsLocationManager extends LitElement {
    static properties = {
        config_membership: { type: Object, reflect:true},
        membership: { type: Object},
        restUrl: { type: String },
        nonce: { type: String },
        pageSize: { type: Number },
        params: { type: Object },
        name: { type: String },
        locations: { type: Array },
        total: { type: Number },
        types: { type: Array },
        accessibilities: { type: Array },
        hardlinks: { type: Object },
        memberAlreadySharedProfileText: { type: String },
        memberShareButtonTextForLocation: { type: String },
        memberShareModalTextForLocation: { type: String },
        languages: { type: Array },
        _baseurl: { type: String },
        _search: { type: String },
        _addressSearch: { type: String },
        _personalisation: { type: Object },
        _accessibility: { type: Array },
        _format: { type: String },
        _pageNumber: { type: Number },
        _type: { state:true, type: Array },
        _currentLocation: { state: true, type: String },
        _currentLocationSidebar: { state: true, type: String },
        _currentLocationData: { state: true, type: Object },
        _currentZone: { state: true, type: Object },
        _currentZoneID: { type: String,state:true },
        _locations: { state: true, type: Array },
        _total: { state: true, type: Number },
        _showEvents: { state: true, type: Boolean },
        _language: { state: true, type: String },
        _from: { state: true, type: String },
        _eventSearch: { state: true, type: String },
    }

    constructor() {
        super();
        this._showEvents = false;
    }

    async connectedCallback() {
        super.connectedCallback();
        this.membership = this.config_membership;
        this.config_membership = null;
        const urlParams = new URLSearchParams(window.location.search);
        this._from = new URLSearchParams(window.location.search).get('from');
        this._eventSearch = urlParams.get('eventsearch')
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-navigation-${this.name}`, this._updateSidebar.bind(this));
        this.eventManager.listen(`allin-location-go-back-${this.name}`, this._handleGoBack.bind(this));
        this.eventManager.listen(`allin-locations-filters-${this.name}`, this._setFilters.bind(this));
        this.eventManager.listen(`allin-location-show-hide-events-${this.name}`, this._showHideEvents.bind(this));
        this.eventManager.listen(`allin-change-page-${this.name}`, this._handleChangePage.bind(this));
        this.eventManager.listen(`allin-location-setter-${this.name}`, this._updateCurrentLocation.bind(this));
        this.eventManager.listen(`allin-location-listings-${this.name}-update`, this._handleContextUpdate.bind(this));
        this.eventManager.listen('popstate', this._paramsFromPopState);
        this.context = {
            membership:this.membership,
            allProvisions: this.allProvisions,
            locations: this._locations,
            location: this._currentLocationData,
            sidebar: this._currentLocationSidebar,
            currentZone: this._currentZone,
            currentZoneID: this._currentZoneID,
            allZoneProvisions: this._allZoneProvisions,
            hardlinks: this.hardlinks,
        };
        this._provider = new ContextProvider(this,{context:locationListingsContext,initialValue:this.context});
        if(this.params){
            this._search = this.params.search??'';
            this._addressSearch = this.params.addressSearch??'';
            //this._personalisation = this.params.personalisation??{};
            this._accessibility = this.params.accessibility?this.params.accessibility.split(','):[];
            this._filterCategories = this.params.filterCategories?this.params.filterCategories.split(','):this._accessibility;
            this._type = this.params.type?this.params.type.split(','):[];
            this._pageNumber = this.params.pageNumber??1;
            this._currentLocation = this.params.currentLocation??'';
            this._currentZoneID = this.params.currentZone??'';
            this._showEvents = this.params.showEvents??false;
            this._locations = {};
            this._locations[this._pageNumber] = this.locations??[];
            this._language = this.params.language??'en';
        }
        if(this.total){
            this._total = this.total;
        }
        this._baseurl = this.hardlinks['listings_locations'];
        this.eventManager.initHistory({params:JSON.stringify(this.params)});
        await this._fetchAllProvisions();

        //check for url parameter
        //if has from param
        //add the correct url to the history api
        cardLinks(this.shadowRoot);
    }
    
    _paramsFromPopState(e) {
        if(this._from){
            e.preventDefault();
            window.location.href=decodeURIComponent(this._from);
        }
        else{
            this._handleGoBack();
        }
    }

    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    _setDocumentTitle(title){
        document.title = `${title} - All In`;
    }

    async firstUpdated(){
        if(!this._currentLocation&&!this._locations.length){
            await this._fetchLocations();
            this.context = {...this.context,locations:this._locations,location:this._currentLocationData};
            this._provider.setValue(this.context);
        }
        if(!this.allProvisions){
            await this._fetchAllProvisions();
            this.context = {...this.context,allProvisions:this.allProvisions};
            this._provider.setValue(this.context);
            this.requestUpdate();
        }
        cardLinks(this.shadowRoot);
    }

    get grid(){
        return this.shadowRoot.querySelector('.grid.cards');
    }

    get legend(){
        return document.getElementById('legend');
    }

    async updated(changedProperties){
        window.scrollTo(0,0);
        if(this._showEvents){
            this.eventManager.addHistory(this._baseurl+this._currentLocation+'/events',{params:JSON.stringify({...this.params,currentLocation:this._currentLocation,showEvents:true})});
        }
        if(changedProperties.has('_currentLocation') || changedProperties.has('_currentZoneID') || changedProperties.has('_currentLocationData')){
            if(this._currentLocation){
                if(this._currentZoneID){
                    this.eventManager.addHistory(this._baseurl+this._currentLocation+'/zone/'+this._currentZoneID,{params:JSON.stringify({...this.params,currentLocation:this._currentLocation,currentZone:this._currentZoneID})});
                    if(!this._currentLocationData){
                        for(let page in this._locations){
                            this._currentLocationData = this._locations[page].find(loc=>loc.id === this._currentLocation);
                            if(this._currentLocationData) break;
                        }
                    }
                    if(!this._currentLocationData){
                        while(!this._currentLocationData && Object.keys(this._locations).length < Math.ceil(this._total / this.pageSize)){
                            await this._fetchLocations(Object.keys(this._locations).length + 1);
                            console.log(this._locations);
                            for(let page in this._locations){
                                this._currentLocationData = this._locations[page].find(loc=>loc.id === this._currentLocation);
                                if(this._currentLocationData) break;
                            }
                        }
                    }
                    console.log(this._currentLocationData);
                    this._currentZone = this._currentLocationData?.zones?.find(z=>z.id===this._currentZoneID);
                    this.eventManager.emit(`allin-header-location-listings-subtitle`,{name:'location-listings-subtitle',text:this._currentZone.name});
                    let crumb = {
                        listing:{url:`${this._baseurl}`,title:msg(`Locations`)},
                        panel:{url:`${this._baseurl}${this._currentLocation}`,title:this._currentLocationData?.name??''},
                        view:{url:`${this._baseurl}${this._currentLocation}/zone/${this._currentZoneID}`,title:this._currentZone.name}
                    }
                    this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);

                    this.context = {...this.context,currentZone:this._currentZone,location:this._currentLocationData};
                }
                else{
                    this.eventManager.addHistory(this._baseurl+this._currentLocation,{params:JSON.stringify({...this.params,currentLocation:this._currentLocation})});
                    if(!this._currentLocationData){
                        for(let page in this._locations){
                            this._currentLocationData = this._locations[page].find(loc=>loc.id === this._currentLocation);
                            if(this._currentLocationData) break;
                        }
                    }
                    let locName = this._currentLocationData?.name??'';
                    this._setDocumentTitle(locName);
                    this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,text:locName});
                    this.eventManager.emit(`allin-header-location-listings-subtitle`,{name:'location-listings-subtitle',text:''});
                    if(locName){
                        let crumb = {
                            listing:{url:`${this._baseurl}`,title:msg(`Locations`)},
                            panel:{url:`${this._baseurl}${this._currentLocation}`,title:locName}
                        }
                        this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
                    }
                    this.context = {...this.context,location:this._currentLocationData};
                }
                this._provider.setValue(this.context);
                this.legend?.classList.add('hide');
                this.renderRoot.querySelector('button,a')?.focus();
            }
            else{
                const params = new URLSearchParams();
                if(this._search) params.append('search', this._search);
                if(this._addressSearch) params.append('addressSearch', this._addressSearch);
                if(this._personalisation) params.append('personalisation', JSON.stringify(this._personalisation));
                if(this._accessibility && this._accessibility.length) params.append('accessibility', this._accessibility.join(','));
                if(this._type && this._type.length) params.append('type', this._type.join(','));
                if(this._format) params.append('format', this._format);
                if(this._pageNumber) params.append('pageNumber', this._pageNumber);
                if(this._language) params.append('language', this._language);
                if(params){
                    this.eventManager.addHistory(`${this._baseurl}?${params.toString()}`,{params:JSON.stringify({...this.params})});
                }
                this._setDocumentTitle('Locations');
                this.eventManager.emit(`allin-header-${this.name}`,{name:this.name,revert:true});
                this.eventManager.emit(`allin-header-location-listings-subtitle`,{name:'location-listings-subtitle',text:''});
                let crumb  = {
                    listing:{url:`${this._baseurl}`,title:msg(`Locations`)},
                }
                this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
                this.legend?.classList.remove('hide');
            }

        }
        if(changedProperties.has('params')){
            this._search = this.params.search??'';
            this._addressSearch = this.params.addressSearch??'';
            //this._personalisation = this.params.personalisation??{};
            if(typeof this.params.accessibility === 'string')
            {
                this.params._accessibility = this.params.accessibility?.split(',')
            }
            this._accessibility = this.params.accessibility?this.params.accessibility:[];
            if(typeof this.params.filterCategories === 'string'){
                this.params._filterCategories = this.params.filterCategories.split(',');
            }
            this._filterCategories = this.params.filterCategories?this.params.filterCategories:[];
            if(typeof this.params.type === 'string') {
                this._type = this.params.type?this.params.type.split(','):"";
            }
            this._language = this.params.language??'en';
            this._type = this.params.type??[];
            this._pageNumber = this.params.pageNumber??1;
            this._currentLocation = this.params.currentLocation??'';
            this._showEvents = this.params.showEvents??false;
            this._locations[this._pageNumber] = this.locations??[];
        }
        // if(changedProperties.has('_from')){
        //     //this.eventManager.addHistory('/listings/locations/'+this._currentLocation+'/events',{params:JSON.stringify({...this.params,currentLocation:this._currentLocation,showEvents:true})});
        //     this.eventManager.addHistory(`/listings/events`);
        //     //this.eventManager.addHistory(`/listings/locations/${this._currentLocation}/events${this._from ? `?from=${encodeURIComponent(this._from)}` : ''}`, { params: JSON.stringify({ ...this.params, currentLocation: this._currentLocation, showEvents: true }) });
        // }
        cardLinks(this.shadowRoot);
    }

    render() {
        let main;
        let aside;
        let after;
        if(this._currentLocation){
            let locationData;
            if(this._currentLocationData){
                locationData = this._currentLocationData;
            }
            else{
                locationData = this._locations[this._pageNumber]?.find(loc=>loc.id === this._currentLocation);
            }
            console.log(locationData);
            if(this._showEvents){
               return html`
                <div class="bg location_all_events">
                    <allin-location-events
                        name="${this.name}"
                        currentLocation="${this._currentLocation}"
                        resturl="${this.restUrl}"
                        nonce="${this.nonce}"
                        locationName="${locationData?.name??''}"
                        accessibilities='${JSON.stringify(this.accessibilities??[])}'
                        perpage="12"
                        paginate="true"
                        .from=${this._from}
                        .hardlinks=${this.hardlinks}
                    >
                    </allin-location-events>
                </div>`;
            }
            if(this._currentZone){
                main=html`
                <allin-zone
                    name="${this.name}"
                    zone="${this._currentZone.id}"
                    resturl="${this.restUrl}"
                    nonce="${this.nonce}"
                ></allin-zone>`;
            }
            else{
            main=html`
            <allin-location
                location="${this._currentLocation}"
                locationdata='${JSON.stringify(locationData)}' 
                resturl="${this.restUrl}"
                nonce="${this.nonce}"
                name="${this.name}"
                allprovisions='${JSON.stringify(this.allProvisions)}'
                .organisation="${locationData?.organisation.id}"
                .membership="${this.membership}"
                memberAlreadySharedProfileText="${this.memberAlreadySharedProfileText}"
                memberShareButtonTextForLocation="${this.memberShareButtonTextForLocation}"
                memberShareModalTextForLocation="${this.memberShareModalTextForLocation}"
                .hardlinks=${this.hardlinks}
            >
            </allin-location>
           `;
            }
            aside=html`<div>${this._currentLocationSidebar}</div>`;
            after = html`<div class="bg location_events">
                <allin-location-zones
                    locationID="${this._currentLocation}"
                    resturl="${this.restUrl}"
                    nonce="${this.nonce}"
                    name="${this.name}"
                    locationName="${locationData?.name??''}"
                    .hardlinks=${this.hardlinks}
                >
                </allin-location-zones>
                <allin-location-events
                    currentLocation="${this._currentLocation}"
                    resturl="${this.restUrl}"
                    nonce="${this.nonce}"
                    name="${this.name}"
                    locationName="${locationData?.name??''}"
                    accessibilities='${JSON.stringify(this.accessibilities??[])}'
                    perpage="3"
                    .hardlinks=${this.hardlinks}
                >
                </allin-location-events>
            </div>`;
            return html`<div class="grid two_column">
            <div class="return back-to-search">
                <a href="#" class="back-to-search-btn" @click=${this._handleGoBack}><span aria-hidden=true>${arrowBack}</span>${msg(`Go back to search`)}</a>
            </div>
            <aside class="sidebar">${aside}</aside>
            <div class="content-wrapper">
                ${main}
            </div>
            </div>
            ${after}
            `;

        }
        else{
            let cards = '';
            if(this._locations[this._pageNumber]?.length){

                cards = this._locations[this._pageNumber].map(location=>{
                    let icons = this._getAccessibilityIcons(location.provisions);
                    return html`
                    <div class="bg_white card card--location">
                        <div class="container container--threetwo">
                            <img src="${location.photo1?.publicUrl??'/wp-content/themes/ace/assets/fallback_new.jpeg'}" alt="${location.photo1?.altText??''}" />
                            ${location.photo1?.altText?.trim()
                                ? html`<allin-alt-block description="${location.photo1?.altText??''}" uid="alt_photo1_${location.id}"></allin-alt-block>`
                                : ''
                            }
                        </div>
                        <div class="card-content">
                            <a
                                href=${`/listings/locations/${location.id}`}
                                @click=${(e) => this._onLocationClick(e, location.id)}
                                class="card_target"
                            >
                                <h3>${location.name}</h3>
                            </a>
                            <p class="small">${location.address1?` ${location.address1}`:''}${location.address2?` ${location.address2}`:''}${location.city?`, ${location.city}`:''}${location.country?`, ${location.country}`:''}</p>
                            <ul class="accessibility-icons" aria-label="${msg(str`${icons.length} accessibility features`)}">
                                ${icons}
                            </ul>
                            ${arrow }
                        </div>
                    </div>`
                });
            }
            aside=html`<div class="sidebar">
            <allin-listings-filters
                name="${this.name}"
                show="checkboxes"
                type='${JSON.stringify(this._type??[])}'
                listingtype="locations"
                languages='${JSON.stringify(this.languages??[])}'
                language='${this._language??'en'}'
                accessibility='${JSON.stringify(this._accessibility??[])}'
                types='${JSON.stringify(this.types??[])}'
                accessibilities='${JSON.stringify(this.accessibilities??[])}'
            ></allin-listings-filters></div>`;
            main=html`
                <allin-listings-filters
                    name="${this.name}"
                    show="search"
                    total="${this._total??0}"
                    search="${this._search??''}"
                    listingtype="locations"
                    addresssearch="${this._addressSearch??''}"
                    typelist='${JSON.stringify(this._type??[])}'
                    language='${this._language??'en'}'
                    accessibilitylist='${JSON.stringify(this._accessibility??[])}'
                    types='${JSON.stringify(this.types??[])}'
                    accessibilities='${JSON.stringify(this.accessibilities??[])}'
                >
                </allin-listings-filters>
                <aside>${aside}</aside>
                <div class="grid grid_33 gap cards">
                    ${cards}
                </div>
                <allin-pagination
                    total="${this._total??0}"
                    currentpage="${this._pageNumber??1}"
                    pagesize="${this.pageSize??9}"
                    name="${this.name}"
                >
                </allin-pagination>
            `;
            return html`<div class="grid two_column">
                <slot name="above-main"></slot>
                ${main}
            </div>
            `;
        }
    }

    _updateSidebar(e){
        this._currentLocationSidebar = e.detail.sidebar;
        this.context = {...this.context,sidebar:this._currentLocationSidebar};
        this._provider.setValue(this.context);
    }

    _handleGoBack(){
        //if the location was reached from the event listings, then go back to the main event listings page, instead of location listings
        if(this._eventSearch){ 
            window.location.href = `${this.hardlinks.listings_events}?${this._eventSearch}`;
            return; 
        }
        this._currentLocation = '';
        this._currentLocationSidebar = '';
        if(this.params.currentLocation){
            this.params.currentLocation = '';
        }
        this._fetchLocations();
    }

    _selectLocation(location){
        this._currentLocation = location;
    }

    //New _selectLocation to allow opening on new tab
    _newSelectLocation(locationId) {
        // clear location state data
        this._currentLocationData = null;
        this._currentZone = null;
        this._currentZoneID = null;
        this.params = {
            ...this.params,
            currentLocation: locationId
        };
        this._currentLocation = locationId;
    }

    _handleChangePage(e){
        const detail = e.detail;
        if('page' in detail && detail.page !== this._pageNumber){
            this._pageNumber = detail.page;
            if(!this._locations[this._pageNumber]||!this._locations[this._pageNumber].length){
                this._fetchLocations();
            }
        }
    }

    _updateCurrentLocation(e){
        this._currentLocationData = e.detail;
        this.context = {...this.context,location:this._currentLocationData};
        this._provider.setValue(this.context);
    }

    _handleContextUpdate(e){
        const detail = e.detail;
        if('currentZone' in detail){
            this._currentZone = detail.currentZone;
            this.context = {...this.context,currentZone:this._currentZone};
            this._provider.setValue(this.context);
        }
        if('currentZoneID' in detail){
            this.oldZoneID = this._currentZoneID;
            this._currentZoneID = detail.currentZoneID;
            this.context = {...this.context,currentZoneID:this._currentZoneID};
            this._provider.setValue(this.context);
        }
        if('allZoneProvisions' in detail){
            this._allZoneProvisions = detail.allZoneProvisions;
            this.context = {...this.context,allZoneProvisions:this._allZoneProvisions};
        }

    }

    _showHideEvents(){
        this._showEvents = !this._showEvents;
    }

    async _setFilters(e){
        const detail = e.detail;
        let shouldFetch = false;
        if('search' in detail && detail.search !== this._search){
            this._search = detail.search;
            shouldFetch = true;
        }
        else if(this._search&&detail.show=='search'){
            this._search=''
            shouldFetch = true;
        }
        if('addressSearch' in detail && detail.addressSearch !== this._addressSearch){
            this._addressSearch = detail.addressSearch;
            shouldFetch = true;
        }
        else if(this._addressSearch&&detail.show=='search'){
            this._addressSearch=''
            shouldFetch = true;
        }
       /*  if('personalisation' in detail && JSON.stringify(detail.personalisation) !== JSON.stringify(this._personalisation)){
            this._personalisation = detail.personalisation;
            shouldFetch = true;
        } */
        if('accessibility' in detail && JSON.stringify(detail.accessibility) !== JSON.stringify(this._accessibility)){
            this._accessibility = detail.accessibility;
            if(!Array.isArray(this._accessibility)){
                this._accessibility = [this._accessibility];
            }
            shouldFetch = true;
        }
        else if(this._accessibility&&detail.show=='checkboxes'){
            //this._accessibility=[];
            this._accessibility = detail.accessibility; // prevents accessibility data from being erased when adding other filter categories
            shouldFetch = true;
        }
        if('type' in detail && JSON.stringify(detail.type) !== JSON.stringify(this._type)){
            this._type = detail.type;
            if(!Array.isArray(this._type)){
                this._type = [this._type];
            }
            shouldFetch = true;
        }
        else if(this._type&&detail.show=='checkboxes'){
            //this._type=[];
            this._type = detail.type; // prevents type data from being erased when adding other filter categories
            shouldFetch = true;
        }
        if('pageNumber' in detail && detail.pageNumber !== this._pageNumber){
            this._pageNumber = detail.pageNumber;
            shouldFetch = true;
        }
        if('language' in detail && detail.language !== this._language){
            this._language = detail.language;
            shouldFetch = true;
        }
        if(JSON.stringify(detail) === "{}"||'reset' in detail){
            shouldFetch = true;
            this._search = '';
            this._addressSearch = '';
            this._accessibility = [];
            this._type = [];
            this._format = '';
            this._pageNumber = 0;
            this._language = this.baseLanguage??'en';
        }
        this.params = {
            ...this.params,
            type:this._type,
            accessibility:this._accessibility,
            addressSearch:this._addressSearch,
            language:this._language,
            search:this._search
        }
        if(shouldFetch){
            this._pageNumber = 1;
            await this._fetchLocations();
        }
    }

    async _fetchAllProvisions(){
        try{
            const response = await fetch(`${this.restUrl}?action=get_all_provisions`,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();
            if(data){
                this.allProvisions = data.provisions??[];
            }
        }
        catch(error){
            console.error('Error fetching all provisions:', error);
        }

    }

    async _fetchLocations(page = null){
        // Fetch locations based on current filters
        const params = new URLSearchParams();
        if(this._search) params.append('search', this._search);
        if(this._addressSearch) params.append('addressSearch', this._addressSearch);
        if(this._personalisation) params.append('personalisation', JSON.stringify(this._personalisation));
        if(this._accessibility && this._accessibility.length) params.append('accessibility', this._accessibility.join(','));
        if(this._type && this._type.length) params.append('type', this._type.join(','));
        if(this._format) params.append('format', this._format);
        if(this._pageNumber) params.append('pageNumber', this._pageNumber);
        if(this._language) params.append('language', this._language);
        if(page) params.append('pageNumber', page);
        if(!page){
            this.eventManager.addHistory(`/listings/locations?${params.toString()}`);
            page = this._pageNumber;
        }
        if(this.perpage) params.append('perpage', this.perpage);
        try{
            this.grid?.classList.add('loading');
            const response = await fetch(`${this.restUrl}?action=get_locations&${params.toString()}`,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();

            if(data){
                this._locations = {...this._locations, [page]: data.data??[]};
                this._total = data.total??0;
                // After fetching location data, then scroll to the top of the updated 'allin-listings-location-manager'
                const container = document.querySelector('allin-listings-location-manager');
                if (container) {
                    container.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        }
        catch(error){
            console.error('Error fetching locations:', error);
        }
        finally{
            this.grid?.classList.remove('loading');
        }
    }

    _getAccessibilityIcons(provisions){
        let accessibilityIcons = [];
        let provisionMap = [];
        this.allProvisions?.forEach(prov=>{
            provisionMap = [...provisionMap,...prov.provisions];
        });
        if(provisions&&provisions.length){
            provisions.forEach(prov=>{
                let provision = provisionMap.find(p=>p.id===prov.standardId);

                if(provision?.filterCategory&&!accessibilityIcons.includes(provision?.filterCategory)){
                    accessibilityIcons.push(provision?.filterCategory);
                }
            });
        }
        accessibilityIcons.sort();
        accessibilityIcons = accessibilityIcons.map(cat=>{
            let icon = this.accessibilities?.find(a=>a.name===cat);
            if(icon){
                return html`<li class="icon" title="${icon.label}">
                    <span class="screen-reader-text">${msg(`{icon.label} icon`)}</span>
                    <span aria-hidden="true">
                        ${unsafeHTML(icon.icon??'')}
                    </span>
                </li>`;
            }
        });
        accessibilityIcons = accessibilityIcons.filter(icon=>icon);
        return accessibilityIcons;
    }

    _onLocationClick(e, locationId) {
        // Only intercept plain left-clicks
        const isPlainLeftClick =
            e.button === 0 &&
            !e.metaKey &&
            !e.ctrlKey &&
            !e.shiftKey &&
            !e.altKey;

        if (!isPlainLeftClick) {
            return; // Let browser handle ctrl+click, middle-click, etc.
        }

        e.preventDefault();
        this._newSelectLocation(locationId);
    }

    static styles = [
        accessibility,
        grid,
        containers,
        sidebar,
        css`

        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }


        h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }
        .return a {
            font-size: 1.25rem;
            font-weight: 700;
        }


        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }

        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }

        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }
        @media (min-width: 1000px) {
            .two_column{
                grid-template-rows:auto auto auto auto auto;
                grid-auto-flow:dense;
                column-gap:4rem;
            }
            aside{
                grid-row:1 / -1;
                grid-column:2 / 3;
            }
        }

        .card{
            background-color:#fff;
            display:grid;
            grid-template-rows:auto 1fr;
            img{
                transition:opacity var(--transition) ease;
            }
        }

        .card .card-content>svg{
            transition:transform var(--transition) ease;
            display:block;
            margin-left:auto;
        }

        .card-content{
            padding:1rem;
        }

        .card a{
            color:var(--allin-highlight-color,#472961);
            text-decoration-gap:0.25rem;
            text-decoration-thickness:1px;
            transition:text-decoration-thickness var(--transition) ease;
        }
        .card:hover{
            a{
                text-decoration-thickness:2px;
            }
            img{
                opacity:0.9;
            }

        }

        .card:hover .card-content>svg{
            transform:translateX(0.5rem);
        }

        .card-content{
            display:grid;
            grid-template-rows:auto auto 1fr auto;
        }

        .accessibility-icons{
            display:flex;
            gap:0.75rem;
            margin:3rem 0;
            flex-wrap:wrap;
        }
        .accessibility-icons li{
            width:2rem;
            height:2rem;
            path,circle,rect,polygon{
                fill:var(--allin-highlight-color,#472961);
            }
            svg{
                width:2rem;
                height:2rem;
                object-fit:contain;
            }

        }

        .loading {
            position: relative;
        }

        .loading::after {
            content: '';
            position: fixed;
            top: 50%;
            left: 50%;
            width: 2rem;
            height: 2rem;
            animation: spin 1s linear infinite;
            z-index: 100;
            background-image: url(/wp-content/themes/ace/assets/wheel.svg);
            background-size: cover;
        }

        @keyframes spin {
            from { transform: translate(-50%, -50%) rotate(0deg); }
            to   { transform: translate(-50%, -50%) rotate(360deg); }
        }

        .location_events{
            margin-top:4rem;
            position:relative;
        }
        .location_all_events{
            position:relative;
        }

        .location_events::before,.location_all_events::before{
            content:'';
            position:absolute;
            top:0;
            bottom:0;
            background-color:var(--allin-bg-color,#ccc);
            z-index:0;
            width:100vw;
            left:50%;
            transform:translateX(-50%);
        }

        allin-location-events{
            position:relative;
            z-index:1;
        }
        allin-location-zones{
            z-index:2;
        }
        aside.sidebar .grid--icon .icon_text p a {
            white-space: normal;
            overflow-wrap: break-word;
            word-break: break-word;
            display: inline;
        }
        @media screen and (max-width: 999px) {
            aside.sidebar{
                display: none;
            }
        }

        .grid.two_column .return.back-to-search a{
            text-decoration: none;
            color: #472961;
        }

        div.item.text p button.link-btn{
            font-weight: 700;
            transition: color var(--transition) ease;
            color: var(--allin-text-color, #472961);
            font-family: var(--allin-font-family, Montserrat, sans-serif);
            font-size: var(--allin-font-size, 1rem);
            padding: 0;
            border: none;
            text-align: left;
            background: transparent;
            cursor: pointer;
        }
        div.item.text p button.link-btn:hover{
            color: var(--allin-hover-color, #8141b9);
        }

        button.btn {
            padding: 1rem;
            border-radius: var(--allin-border-radius, 0.5rem);
            width: fit-content;
            text-align: center;
            font-family: var(--allin-font-family, Montserrat, sans-serif);
            font-size: var(--allin-font-size, 1rem);
            color: var(--allin-button-text-color, #fff);
            font-weight: (var(--allin-button-font-weight, 600));
            cursor: pointer;
            border: none;
            background: var(--allin-button-bg-color, #472961);
            transition: background var(--transition) ease;
        }
        button.btn:hover{
            background: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
            color: rgb(52,52,52);
        }

        `
        ];
}
